import React from 'react';
import { Star, Clock, Users, BookOpen, ChevronRight } from 'lucide-react';

const CourseCard = ({ course, onEnroll }) => (
  <div className="card">
    <img src={course.image} alt={course.title} />
    <div className="card-content">
      <h3>{course.title}</h3>
      <p>{course.description}</p>
      <div className="details">
        <span><Star size={14} /> {course.rating} ({course.reviews})</span>
        <span><Users size={14} /> {course.students}</span>
      </div>
      <div className="details">
        <span><Clock size={14} /> {course.duration}</span>
        <span><BookOpen size={14} /> {course.lessons}</span>
      </div>
      <button className="enroll" onClick={onEnroll}>
        Enroll Now <ChevronRight size={14} style={{ marginLeft: '8px' }} />
      </button>
    </div>
  </div>
);

export default CourseCard;
